import React, { Fragment } from 'react';

import { EconomySavingsMessage } from './economy-savings.styles';
import { getMessage } from './economy-savings.utils';

import Loading from '../../../../shared/components/loading/Loading';

const defaultProps = {
    boardName: null,
    loading: false,
};

export const EconomySavings = ({ boardName, boardData, loading }) => (
    <Fragment>
        {
            loading ? (
                <Loading height={20} spinnerSize={20} />
            ) : (
                <EconomySavingsMessage>{getMessage(boardName, boardData)}</EconomySavingsMessage>
            )
        }
    </Fragment>
);

EconomySavings.defaultProps = defaultProps;
